import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { AutenticacionService } from './autenticacion.service';
import { UbicacionService } from './ubicacion.service';
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GatewayService {

  constructor(private autenticacionService: AutenticacionService, private ubicacionService: UbicacionService, 
    private http: HttpClient) {
  }
  
  public get<T>(url: string): Observable<T> {
    const urlApi = this.ubicacionService.getApiFirmaUrl();
    const token = this.autenticacionService.obtenerToken();

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };
    
    return this.http.get<any>(urlApi + url, httpOptions).pipe(map((r) => r));
  }

  public post<T>(url: string, data: any): Observable<T> {
    const urlApi = this.ubicacionService.getApiFirmaUrl();  
    const token = this.autenticacionService.obtenerToken();
      
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };
    
    return this.http.post<any>(urlApi + url, data, httpOptions).pipe(map((r) => r));
  }
}
